import { useEffect } from 'react'
import { useEditSession } from '@/core/store/editSession'
import { ThemeMode } from '@/core/store/uiState'

const SYSTEM_DARK_QUERY = '(prefers-color-scheme: dark)'

export function useApplyTheme(): void {
  const themeMode = useEditSession((state) => state.themeMode)

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      throw new Error('Theme selection requires window.matchMedia support')
    }
    const media = window.matchMedia(SYSTEM_DARK_QUERY)
    const apply = () => {
      const isDark = themeMode === ThemeMode.Dark
        || (themeMode === ThemeMode.System && media.matches)
      document.documentElement.classList.toggle('dark', isDark)
      document.documentElement.style.colorScheme = isDark ? 'dark' : 'light'
      document.documentElement.dataset.theme = isDark ? ThemeMode.Dark : ThemeMode.Light
    }
    apply()
    media.addEventListener('change', apply)
    return () => media.removeEventListener('change', apply)
  }, [themeMode])
}
